import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';
import logoSvg from '../assets/logo.svg';

function Chat() {
  return (
    <div className="chat-page">
      <div className="logo-container">
        <Link to="/" className="logo">
          <img src={logoSvg} alt="New Therapy AI" className="chat-logo-image" />
        </Link>
      </div>
      <div className="chat-content">
        <h2>Chat with our AI</h2> <br />
        <p>Interface coming soon...</p>
        <div className="animation-container">
          <iframe
            src={process.env.PUBLIC_URL + '/assets/animation01.html'}
            title="Branding Animation"
            className="branding-animation"
            frameBorder="0"
            scrolling="no"
            allow="autoplay"
          />
        </div>
      </div>
    </div>
  );
}

export default Chat; 